import React from 'react';
import { DownloadIcon, LinkedinIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { profile } from '../data/profile';
import { downloadResume } from '../utils/resumePdf';
import { AnimatedBackdrop } from './AnimatedBackdrop';
import { ContactForm } from './ContactForm';
import { Reveal } from './Reveal';
export function ContactSection() {
  return <section id="contact" className="relative w-full overflow-hidden bg-navy py-20 lg:py-28" data-id="element-196" data-mp="2pgnqutx2d54x">
      <AnimatedBackdrop data-id="element-197" data-mp="3d94bnc86rb7x" />

      <div className="relative mx-auto max-w-shell px-6 sm:px-8" data-id="element-198" data-mp="3i7e259iytnn7">
        <Reveal data-id="element-199" data-mp="3i6mimx2n7gda">
          <div className="flex items-center gap-3" data-id="element-200" data-mp="3i51qfe3sw9il">
            <span className="h-px w-8 bg-metal" aria-hidden="true" data-id="element-201" data-mp="346l9yvg4z4n9" />
            <span className="text-[11px] font-semibold uppercase tracking-label text-metal-light" data-id="element-202" data-mp="388yddd7euqgv">
              Contact &amp; Board Inquiries
            </span>
          </div>

          <h2 className="mt-6 max-w-3xl font-serif text-[32px] font-semibold leading-[1.15] tracking-[-0.015em] text-white sm:text-4xl lg:text-[46px]" data-id="element-203" data-mp="1suu5qoljsv5t">
            {profile.closing}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-[0.4fr_0.6fr] lg:gap-16" data-id="element-204" data-mp="2nbk61qlact2">
          <Reveal data-id="element-205" data-mp="gmut2wr85s6f">
            <div className="flex h-full flex-col" data-id="element-206" data-mp="gncmzmqezub6">
              <h3 className="text-[12px] font-semibold uppercase tracking-label text-white/50" data-id="element-207" data-mp="gkqe9jrsf8rd">
                Direct contact
              </h3>

              <dl className="mt-7 space-y-6" data-id="element-208" data-mp="qkhd1xnds9x9">
                <div className="flex items-start gap-4 border-b border-white/10 pb-6" data-id="element-209" data-mp="qj68vwq0x05m">
                  <PhoneIcon className="mt-1 h-4 w-4 shrink-0 text-metal-light" aria-hidden="true" data-id="element-210" data-mp="lleemw1wp1y9" />
                  <div data-id="element-211" data-mp="10aan2u7vkgze">
                    <dt className="text-[12px] font-medium uppercase tracking-label text-white/45" data-id="element-212" data-mp="10cn1ixefc97p">
                      Phone
                    </dt>
                    <dd className="mt-1.5" data-id="element-213" data-mp="19cjtp900vq7i">
                      <a href={profile.phoneHref} className="font-serif text-xl text-white transition-colors duration-150 ease-premium hover:text-metal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-metal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-214" data-mp="1995qxzng5ezj">
                        {profile.phone}
                      </a>
                    </dd>
                  </div>
                </div>

                <div className="flex items-start gap-4 border-b border-white/10 pb-6" data-id="element-215" data-mp="fs8oodg1d2hs">
                  <MailIcon className="mt-1 h-4 w-4 shrink-0 text-metal-light" aria-hidden="true" data-id="element-216" data-mp="krld32mk2hmh" />
                  <div className="min-w-0" data-id="element-217" data-mp="pqogyjqsuhsv">
                    <dt className="text-[12px] font-medium uppercase tracking-label text-white/45" data-id="element-218" data-mp="unf0jh1tbvj1">
                      Email
                    </dt>
                    <dd className="mt-1.5" data-id="element-219" data-mp="yn5u1siq4pr9">
                      <a href={`mailto:${profile.email}`} className="break-all font-serif text-xl text-white transition-colors duration-150 ease-premium hover:text-metal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-metal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-220" data-mp="2wftfq8cz2lvr">
                        {profile.email}
                      </a>
                    </dd>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-221" data-mp="2f70i0txzi14g">
                  <LinkedinIcon className="mt-1 h-4 w-4 shrink-0 text-metal-light" aria-hidden="true" data-id="element-222" data-mp="3bvq1upt693t2" />
                  <div className="min-w-0" data-id="element-223" data-mp="36xon2h2s3qne">
                    <dt className="text-[12px] font-medium uppercase tracking-label text-white/45" data-id="element-224" data-mp="32us6sx0po6mm">
                      LinkedIn
                    </dt>
                    <dd className="mt-1.5" data-id="element-225" data-mp="2xyb9pdbjahxe">
                      <a href={profile.linkedinUrl} target="_blank" rel="noreferrer noopener" className="break-all text-[15px] font-medium text-white underline decoration-metal decoration-1 underline-offset-4 transition-colors duration-150 ease-premium hover:text-metal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-metal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-226" data-mp="1rgo6za7fzo9n">
                        {profile.linkedinLabel}
                      </a>
                    </dd>
                  </div>
                </div>
              </dl>

              <div className="mt-9 flex flex-col gap-3 sm:flex-row lg:mt-auto lg:pt-10" data-id="element-227" data-mp="1yg3o5wbh8nc">
                <a href={profile.linkedinUrl} target="_blank" rel="noreferrer noopener" className="inline-flex items-center justify-center gap-2.5 border border-white/25 px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-150 ease-premium hover:border-metal hover:text-metal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-metal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-228" data-mp="3k3t3tsm6qi0b">
                  <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-229" data-mp="213tnuf5cfph4" />
                  LinkedIn Profile
                </a>
                <button type="button" onClick={downloadResume} className="inline-flex items-center justify-center gap-2.5 bg-white px-6 py-3.5 text-sm font-semibold text-navy transition-colors duration-150 ease-premium hover:bg-metal-pale focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-metal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-230" data-mp="2f3uvcdg45v5k">
                  <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-231" data-mp="1rejvqzai26t0" />
                  Download Resume
                </button>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.07} data-id="element-232" data-mp="yqnwpnxgk2t2">
            <ContactForm data-id="element-233" data-mp="ypcsjn03ot1f" />
          </Reveal>
        </div>
      </div>
    </section>;
}